export default (function (_ref, inject) {
  var app = _ref.app;
  inject('irisWandhCSTest', true);
});
export var useIrisWandhCSTest = function useIrisWandhCSTest() {
  var _useNuxtApp = useNuxtApp(),
    $irisWandhCSTest = _useNuxtApp.$irisWandhCSTest;
  return $irisWandhCSTest;
};